"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperator = exports.Operator = void 0;
const with_class_name_1 = require("../with-class-name");
const change_case_1 = require("change-case");
class Operator extends with_class_name_1.WithClassName {
    get readableName() {
        return this.name ? (0, change_case_1.sentenceCase)(this.name) : "";
    }
    static getOp(operatorType, name) {
        return Operator.allOperators.find((o) => o.operatorType === operatorType && o.name === name);
    }
}
exports.Operator = Operator;
Operator.allOperators = [
    ...getNumberOperators("number"),
    getOperator("string", "matches"),
    getOperator("string", "contains"),
    getOperator("string", "endsWith"),
    getOperator("string", "iRegexIn"),
    getOperator("date", "before"),
    getOperator("date", "inLast"),
    getOperator("date", "between"),
    getOperator("date", "comingUpInNext"),
    getOperator("date", "inNextNoYearShift"),
];
function getOperator(operatorType, name) {
    let operator = new Operator();
    operator.operatorType = operatorType;
    operator.name = name;
    return operator;
}
exports.getOperator = getOperator;
function getNumberOperators(operatorType) {
    return [
        getOperator(operatorType, ">"),
        getOperator(operatorType, ">="),
        getOperator(operatorType, "<"),
        getOperator(operatorType, "<="),
        getOperator(operatorType, "="),
        getOperator(operatorType, "between"),
    ];
}



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/casa-rules-v2/operator.js
// module id = 1225
// module chunks = 0